import { createSlice } from "@reduxjs/toolkit";

type FeedbackSurvey = {
  surveyId: string;
  parentType: string;
  parentId: string;
  enableButton: boolean;
  failedStatus: string;
};

type FeedbackSurveyState = {
  feedbackSurveys: FeedbackSurvey[];
};
const initialState: FeedbackSurveyState = {
  feedbackSurveys: []
};

const EnabledFeedbackBtnSlice = createSlice({
  name: "EnabledFeedbackBtnSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.feedbackSurveys = action.payload;
    }
  }
});

export default EnabledFeedbackBtnSlice;

export const EnabledFeedbackBtnSliceActions = EnabledFeedbackBtnSlice.actions;
